export const ALLMODELS = "ALLMODELS";
export const getAllModels = (data) => {
    return {
        type: ALLMODELS,
        payload: data
    }
}